// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2qrgt","head":"Table_head__nhyPJ","col":"Table_col__29FKb"};